import { useTranslation } from 'react-i18next';

import { NotFound } from '@/pages';

export const NotFoundRoute = () => {
  const { t } = useTranslation('common');

  return <NotFound title="404" content={t('routes.weCouldnTFindThe')} />;
};
